import { TabContext, TabPanel } from "@mui/lab";
import { Tab, Typography } from "@mui/material";
import { Box } from "@mui/system";
import React, { useState } from "react";
import { StyledTabList, TabContentWrap, TabsWrap } from "./styledAboutMe";
import { tabsData } from "./tabsData";

function AboutMeTabs() {
  const [value, setValue] = useState("0");

  const handleChange = (_, newValue) => {
    setValue(newValue);
  };

  return (
    <TabsWrap item xs={12}>
      <TabContext value={value} onChange={handleChange}>
        <Box
          sx={{
            borderBottom: 1,
            borderColor: "white",
            width: "470px",
          }}
        >
          <StyledTabList
            onChange={handleChange}
            aria-label="about me tabs"
            textColor="inherit"
          >
            {tabsData.map((tab, index) => (
              <Tab label={tab.label} value={index.toString()} key={index} />
            ))}
          </StyledTabList>
        </Box>
        {tabsData.map((tab, index) => (
          <TabPanel key={index} value={index.toString()}>
            {tab.sections.map((section, i) => (
              <TabContentWrap key={i} sx={{ mb: "10px" }}>
                <Typography variant="h6" color="#7C9473" key={`tab_header_${i}`}>
                  {section.header}
                </Typography>
                <Typography variant="h10" key={`tab_context_${i}`}>
                  {section.context}
                </Typography>
              </TabContentWrap>
            ))}
          </TabPanel>
        ))}
      </TabContext>
    </TabsWrap>
  );
}

export default AboutMeTabs;
